import { ConsumerAutoSubmissionView } from './components/consumer-auto-submission-view/consumer-auto-submission-view.component'

export const ConsumerAutoSubmissionStep = () => {
  return <ConsumerAutoSubmissionView />
}
